/* Blackstone Suomi — premium-interaktiot (kunnioittaa prefers-reduced-motion) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll-reveal: .bs-reveal-osiot liukuvat näkyviin */
  var revealables = document.querySelectorAll(
    '.bs-size-card, .bs-sizes__head, .bs-sizes__eseries, .bs-compare__scroll, .bs-hero__chips li, .bs-cat-tile, .bs-brand__media, .bs-brand__content, .bs-versa-card, .bs-versa__head, .bs-kit__step, .bs-help-card, .bs-contact-card, .bs-video-card, .bs-cats__head, .bs-help__head'
  );
  if (!reduceMotion && 'IntersectionObserver' in window) {
    revealables.forEach(function (el, i) {
      el.classList.add('bs-reveal');
      el.style.transitionDelay = (i % 4) * 60 + 'ms';
    });
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bs-revealed');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealables.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* Paistopinta-viivaimet kasvavat oikeaan mittaansa näkyviin tullessaan */
  var rulers = document.querySelectorAll('.bs-size-card__ruler-fill');
  if (rulers.length && 'IntersectionObserver' in window) {
    rulers.forEach(function (bar) {
      bar.dataset.targetWidth = bar.style.width;
      if (!reduceMotion) bar.style.width = '0%';
    });
    if (!reduceMotion) {
      var rulerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var bar = entry.target;
              requestAnimationFrame(function () {
                bar.style.width = bar.dataset.targetWidth;
              });
              rulerObserver.unobserve(bar);
            }
          });
        },
        { threshold: 0.4 }
      );
      rulers.forEach(function (bar) {
        rulerObserver.observe(bar);
      });
    }
  }

  /* Vertailutaulukko: koko sarakkeen korostus hoverilla */
  var compareTable = document.querySelector('.bs-compare table');
  if (compareTable) {
    compareTable.addEventListener('mouseover', function (event) {
      var cell = event.target.closest('td, thead th');
      if (!cell || cell.cellIndex === 0) return;
      highlightColumn(cell.cellIndex, true);
    });
    compareTable.addEventListener('mouseout', function (event) {
      var cell = event.target.closest('td, thead th');
      if (!cell || cell.cellIndex === 0) return;
      highlightColumn(cell.cellIndex, false);
    });
  }
  function highlightColumn(index, on) {
    compareTable.querySelectorAll('tr').forEach(function (row) {
      var cell = row.cells[index];
      if (cell) cell.classList.toggle('bs-col-hover', on);
    });
  }

  /* Hero: kevyt parallaksi videolle */
  var heroMedia = document.querySelector('.bs-hero__media');
  if (heroMedia && !reduceMotion) {
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY;
          if (y < window.innerHeight) {
            heroMedia.style.transform = 'translateY(' + y * 0.25 + 'px) scale(1.06)';
          }
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  /* Tunnusluvut laskevat ylös näkyviin tullessaan */
  var statNumbers = document.querySelectorAll('.bs-stat-number[data-target]');
  if (statNumbers.length && 'IntersectionObserver' in window && !reduceMotion) {
    var statObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          statObserver.unobserve(el);
          var target = parseInt(el.dataset.target, 10);
          var prefix = el.dataset.prefix || '';
          var suffix = el.dataset.suffix || '';
          var duration = 1600;
          var start = null;
          function tick(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            var value = Math.round(target * eased);
            el.textContent = prefix + value.toLocaleString('fi-FI') + suffix;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.5 }
    );
    statNumbers.forEach(function (el) {
      statObserver.observe(el);
    });
  }

  /* FAQ: plus kääntyy ristiksi avattaessa */
  document.querySelectorAll('.bs-faq details').forEach(function (item) {
    item.addEventListener('toggle', function () {
      var icon = item.querySelector('summary span[aria-hidden]');
      if (icon) icon.style.transform = item.open ? 'rotate(45deg)' : 'rotate(0deg)';
    });
  });

  /* GA4-tapahtumat: mitä kävijät oikeasti klikkaavat */
  function bsTrack(name, label) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, { event_category: 'bs_interaction', event_label: label });
    }
  }

  document.querySelectorAll('.bs-size-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var size = card.querySelector('.bs-size-card__size');
      bsTrack('size_card_click', size ? size.textContent.trim() : '');
    });
  });

  if (compareTable) {
    compareTable.addEventListener('click', function (event) {
      var link = event.target.closest('thead a');
      if (link) bsTrack('comparison_model_click', link.textContent.trim());
    });
  }

  var stickyBtn = document.getElementById('bs-sticky-atc-button');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      bsTrack('sticky_atc_click', location.pathname);
    });
  }

  document.addEventListener('click', function (event) {
    var upsell = event.target.closest('.bs-cart-upsell__add');
    if (upsell) bsTrack('cart_upsell_add', upsell.getAttribute('aria-label') || '');
    var kit = event.target.closest('[data-bs-event]');
    if (kit) bsTrack(kit.dataset.bsEvent, kit.dataset.bsLabel || '');
    var heroCta = event.target.closest('.bs-hero__actions a');
    if (heroCta) bsTrack('hero_cta_click', heroCta.textContent.trim());
  });
})();
